<template>
  <a-card :bordered="false">
    <div>
      <a-button type="primary" @click="openModel">添加关联账号</a-button>
    </div>
    <custom-page-table
      style="margin-top: 16px;"
      ref="table"
      rowKey="id"
      query-path="directPresale/related/selectAccountList"
      base-key="directPresaleUrl"
      :queryParams="queryParams"
      :columns="columns"
    >
      <span slot="state" slot-scope="rowItem">
        {{ rowItem.record.state == 1 ? '启用' : '禁用' }}
      </span>
      <span slot="action" slot-scope="rowItem">
        <a @click="editEvent(rowItem.record)">编辑</a>
        <a-divider type="vertical"/>
        <a v-if="rowItem.record.state == 0" @click="enableEvent(rowItem.record.id)">启用</a>
        <a v-else-if="rowItem.record.state == 1" @click="forbiddenEvent(rowItem.record.id)" style="color: red;">禁用</a>
      </span>
    </custom-page-table>
    <a-modal title="添加关联账号" width="700px" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :rules="rules" :model="ruleForm" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="供应商名称" prop="supplierName">
          <a-input v-model.trim="ruleForm.supplierName" style="width: 400px;" :maxLength="6"
                   placeholder="仅用于区分标识数据来源，6个字内"
          ></a-input>
        </a-form-model-item>
        <a-form-model-item label="商户号" prop="userName">
          <a-input v-model.trim="ruleForm.userName" style="width: 400px;" placeholder="请输入商户号"
                   :maxLength="25"></a-input>
        </a-form-model-item>
        <a-form-model-item label="秘钥" prop="relatedKey">
          <a-input v-model.trim="ruleForm.relatedKey" placeholder="请输入企业私钥" style="width: 400px;"
                   :maxLength="25"></a-input>
        </a-form-model-item>
        <a-form-model-item label="下单方式" prop="orderMethod">
          <a-radio-group v-model="ruleForm.orderMethod">
            <a-radio :value="1">自动下单</a-radio>
            <a-radio :value="0">手动下单</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="offsetCol">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存设置</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'AddAccount',
  data() {
    return {
      submitLoading: false,
      columns: [
        {
          title: '供应商名称',
          dataIndex: 'supplierName'
        },
        {
          title: '商户号',
          dataIndex: 'userName'
        },
        {
          title: '秘钥',
          dataIndex: 'relatedKey'
        },
        {
          title: '状态',
          dataIndex: 'state',
          scopedSlots: { customRender: 'state' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
      offsetCol: { offset: 5 },
      visible: false,
      ruleForm: {
        id: 0,
        merchantId: this.$store.getters.userInfo.merchantId,
        relatedKey: '',
        relatedType: this.$route.query.serverUniqueId == 100017 ? 1 : 2,
        supplierName: '',
        userName: '',
        passWord: '',
        orderMethod: 1,
        relatedUrl: ''
      },
      rules: {
        supplierName: [
          { required: true, message: '请输入供应商名称', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        relatedKey: [
          { required: true, message: '请输入企业私钥', trigger: 'blur' }
        ],
        orderMethod: [
          { required: true, message: '请选择下单方式', trigger: 'change' }
        ]
      },
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        relatedType: this.$route.query.serverUniqueId == 100017 ? 1 : 2
      },
      submitFormData: ''
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'VirtualConnection', title: '商品绑定' },
      { name: 'VirtualOrderConnection', title: '订单直连' },
      { name: 'VirtualRelationAccount', title: '关联账号' }
    ])
  },
  methods: {
    //启用事件
    enableEvent(id) {
      this.updateProviderStatus(id, 1)
    },
    //编辑事件
    editEvent(item) {
      this.ruleForm = item
      this.visible = true
    },
    //禁用事件
    forbiddenEvent(id) {
      this.updateProviderStatus(id, 0)
    },
    //状态更新
    updateProviderStatus(id, status) {
      let parms = {
        id: id,
        merchantId: this.$store.getters.userInfo.merchantId,
        relatedType: this.$route.query.serverUniqueId == 100017 ? 1 : 2,
        state: status
      }
      this.getHttpServices().getDirectPresaleService().post('directPresale/related/updateAccountState', parms)
        .then(res => {
          this.$refs.table.refresh(true)
          this.$message.success('状态更新成功')
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //提交事件
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.submitLoading = true
      this.getLogUtils().logWithTag('submitData', this.submitFormData)
      this.getHttpServices().getDirectPresaleService().post('directPresale/related/saveAccount', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.visible = false
        this.$message.success('添加账号成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    openModel() {
      this.visible = true
      this.submitLoading = false
      this.ruleForm = {
        id: 0,
        merchantId: this.$store.getters.userInfo.merchantId,
        relatedKey: '',
        relatedType: this.$route.query.serverUniqueId == 100017 ? 1 : 2,
        supplierName: '',
        userName: '',
        passWord: '',
        orderMethod: 1,
        relatedUrl: ''
      }
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>
<style scoped></style>
